.gas-rental-reserve {
    margin-top: var(--gas-space-l);
    padding: var(--gas-space-l);
    border: 1px solid var(--gas-color-border, #e1e8ed);
    border-radius: var(--gas-radius-l);
    background: var(--gas-color-surface-default, #fff);
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-m);
    max-width: 540px;
}

.gas-rental-reserve__title {
    margin: 0;
    font-size: var(--gas-text-l);
}

.gas-rental-reserve__dates {
    display: flex;
    gap: var(--gas-space-m);
    flex-wrap: wrap;
}

.gas-rental-reserve__dates label {
    display: flex;
    flex-direction: column;
    gap: var(--gas-space-2xs, 4px);
    flex: 1;
    min-width: 200px;
}

.gas-rental-reserve__dates span {
    font-size: var(--gas-text-s);
    color: var(--gas-text-muted);
}

.gas-rental-reserve__dates input {
    padding: var(--gas-space-2xs) var(--gas-space-xs);
    border: 1px solid var(--gas-color-border, #e1e8ed);
    border-radius: var(--gas-radius-s);
    font: inherit;
}

.gas-rental-reserve__available {
    color: var(--gas-color-success);
    font-weight: 600;
    margin: 0;
}

.gas-rental-reserve__unavailable {
    color: var(--gas-color-danger);
    font-weight: 600;
    margin: 0;
}

.gas-rental-reserve__checking {
    color: var(--gas-text-muted);
    margin: 0;
}

.gas-rental-reserve__price {
    display: flex;
    align-items: baseline;
    gap: var(--gas-space-xs);
    margin: 0;
    font-size: var(--gas-text-l);
}

.gas-rental-reserve__price-strike {
    text-decoration: line-through;
    color: var(--gas-text-muted);
    font-size: var(--gas-text-m);
}

.gas-rental-reserve__price-member {
    font-size: var(--gas-text-s);
    color: var(--gas-color-success);
    font-style: normal;
}

.gas-rental-reserve__login {
    margin: 0;
    color: var(--gas-text-muted);
}

.gas-rental-reserve__success {
    color: var(--gas-color-success);
    font-weight: 600;
}

/* Mini-calendrier de disponibilité (§3.8). */
.gas-rental-reserve__calendar {
    margin-bottom: var(--gas-space-m);
}

.gas-rental-reserve__calendar-title {
    font-size: var(--gas-text-m);
    margin: 0 0 var(--gas-space-xs);
}

/* Le calendrier est désormais le composant partagé GasRangeCalendar (kit).
   Ses styles vivent dans shared/kit/components/GasRangeCalendar.css. */

.gas-rental-reserve__range {
    display: flex;
    gap: var(--gas-space-m, 10px);
    flex-wrap: wrap;
}
.gas-rental-reserve__range-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.gas-rental-reserve__range-label {
    font-size: var(--gas-text-s, 8px);
    color: var(--gas-text-muted, #6b7d85);
}
.gas-rental-reserve__hint {
    font-size: var(--gas-text-s, 8.5px);
    color: var(--gas-text-muted, #6b7d85);
    margin: 0;
}
.gas-rental-reserve__price--free {
    color: var(--gas-color-success, #2e7d4f);
    font-weight: 600;
}
.gas-rental-reserve__submit { align-self: flex-start; }

.gas-rental-reserve__capacity {
    margin: 0;
    font-size: var(--gas-text-s, 8.5px);
    color: var(--gas-text-muted, #6b7d85);
}

/* Kit + accessoires (info) */
.gas-rental-reserve__kit,
.gas-rental-reserve__addons {
    margin: var(--gas-space-s) 0;
    padding: var(--gas-space-s) var(--gas-space-m);
    background: var(--gas-color-surface-muted, #f1f6f7);
    border-radius: var(--gas-radius-m);
}
.gas-rental-reserve__kit-title,
.gas-rental-reserve__addons-title {
    font-weight: 600;
    margin: 0 0 var(--gas-space-2xs, 6px);
}
.gas-rental-reserve__kit-list,
.gas-rental-reserve__addons-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    gap: var(--gas-space-s);
}
.gas-rental-reserve__kit-list li,
.gas-rental-reserve__addons-list li {
    display: flex;
    align-items: center;
    gap: var(--gas-space-2xs, 6px);
    font-size: var(--gas-text-s, 8.75px);
}
.gas-rental-reserve__kit-list img,
.gas-rental-reserve__addons-list img {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: var(--gas-radius-s, 6px);
}
